<app-state-section [state]="sectionState" *ngIf="shipment">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">{{'shipments.Integration' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="card-content">
      <mat-divider></mat-divider>

      <div class="flat-tab-group__wrapper">
        <mat-tab-group
          class="flat-tab-group"
          [mat-stretch-tabs]="false"
          [selectedIndex]="activeIntegrationTab"
          [dir]="layoutDirection$ | async"
          (selectedIndexChange)="handleIntegrationTabChange($event)"
        >
          <mat-tab *ngFor="let tab of integrationTabs; let i = index;" class="flat-tab-group__tab">
            <ng-template mat-tab-label>
              <img class="media__service" [src]="tab.url" />
            </ng-template>

            <ng-container *ngIf="tab.id === -1">
              <ng-container
                *ngTemplateOutlet="legacyIntegrationTemplate; context: {
            integrate: !shipment.isVerifiedByBayan,
            integrated: shipment.isVerifiedByBayan,
            title: 'shipments.IntegrateWithBayan' | translate,
            action: downloadBayanPDF,
            integrateAction: integrateWithBayan,
            integrateDisabled: isBayanDisabled,
            integrateDisabledReasons: bayanMissingInfo,
            actionLabel: 'shipments.EWaybill.EWaybill' | translate,
            cancelAction: cancelBayanWaybills,
            logs: shipment.requestLogHistory
            }"
              ></ng-container>
            </ng-container>

            <ng-container *ngIf="tab.id === -2">
              <ng-container
                *ngTemplateOutlet="legacyIntegrationTemplate; context: {
            integrate: !shipment.wccId && shipment.fleet?.id && shipment.driver?.id && shipment.truck?.id,
            integrated: shipment.wccId,
            title: 'shipments.IntegrateWithCement' | translate,
            action: cementInfoModal.showModal.bind(cementInfoModal),
            integrateAction: integrateWithCement,
            actionLabel: 'shipments.Details' | translate,
            logs: cementLogs
            }"
              ></ng-container>
            </ng-container>

            <ng-container *ngIf="tab.id !== -1 && tab.id !== -2">
              <div class="px-6 my-3">
                <app-row align="center">
                  <app-col class="small">{{'shipments.Integrations.Action' | translate}}</app-col>
                  <app-col cols="auto" class="small">{{'shipments.Integrations.NoOfCalls' | translate}}</app-col>
                </app-row>
              </div>
              <div *ngFor="let actionName of tab?.actions" class="px-6 mb-3">
                <app-row align="center">
                  <app-col>
                    <button
                      [disabled]="disabledAction[actionName]"
                      mat-button
                      class="small text-primary p-0"
                      (click)="submitAction(actionName, tab.integrationType)"
                    >
                      {{('shipments.Integrations.' + actionName + (isB2c ? 'Integration' :'')) | translate}}
                    </button>
                    <ng-container *ngIf="(integrationActions[actionName]?.logs || []) as logs">
                      <div class="small text-400" *ngIf="logs?.length">
                        {{'shipments.Integrations.LastCallWas' | translate }}
                        <span
                          [class.text-success]="logs[logs.length - 1]?.latestStatus === IntegrationActionStatus.Success"
                          [class.text-warn]="logs[logs.length - 1]?.latestStatus === IntegrationActionStatus.Failed"
                        >
                          {{logs[logs.length - 1]?.latestStatus}}
                        </span>
                      </div>
                    </ng-container>
                  </app-col>
                  <app-col cols="auto">
                    <app-rect-tag (click)="actionPanels[actionName] = !actionPanels[actionName]">
                      {{integrationActions[actionName]?.logs?.length || 0}}
                      <span class="align-middle" *ngIf="integrationActions[actionName]?.logs?.length">
                        <span class="px-1 text-300">|</span>
                        <app-icon
                          [name]="actionPanels[actionName] ? 'arrow_drop_up' : 'arrow_drop_down' "
                          type="MaterialDesign"
                          size="xs"
                          class="align-middle"
                        ></app-icon>
                      </span>
                    </app-rect-tag>
                  </app-col>
                </app-row>

                <mat-accordion [hideToggle] *ngIf="integrationActions[actionName]?.logs?.length">
                  <mat-expansion-panel [expanded]="actionPanels[actionName]" class="mat-elevation-z0">
                    <div class="timeline time-line--sm-bullet mt-3">
                      <div class="timeline__item" *ngFor="let log of integrationActions[actionName]?.logs">
                        <span class="timeline__bullet">
                          <span class="timeline__bullet-shape"></span>
                        </span>
                        <div class="timeline__item-label text-300 small">{{log.createdAt | date:'medium'}}</div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </ng-container>
          </mat-tab>
        </mat-tab-group>
      </div>

      <span *ngIf="!integrationTabs?.length" class="small text-400 mx-3">{{ 'General.NoDataAvailableYet' | translate }}</span>
    </mat-card-content>
  </mat-card>
</app-state-section>

<app-modal
  #cementInfoModal
  [title]="'shipments.IdispoInfo' | translate"
  [subTitle]="shipment.name"
  [maxWidth]="800"
  [padding]="20"
  [textColor]="'var(--color-dark)'"
  [editCloseIcon]="true"
  (closeClicked)="onCloseCementDialog()"
>
  <div *ngIf="cementInfoModal.isModalOpened">
    <app-cement-info [shipment]="shipment"></app-cement-info>
  </div>
</app-modal>

<ng-template
  #legacyIntegrationTemplate
  let-integrated="integrated"
  let-integrate="integrate"
  let-action="action"
  let-cancelAction="cancelAction"
  let-integrateAction="integrateAction"
  let-integrateDisabled="integrateDisabled"
  let-integrateDisabledReasons="integrateDisabledReasons"
  let-title="title"
  let-actionLabel="actionLabel"
  let-logs="logs"
>
  <div class="flat-tab-group__legacy-content">
    <div class="px-6 mb-2">
      <div class="dashed-box">
        <app-row>
          <app-col cols="12" sm="6" md="9" lg="9" xl="9">
            <div>
              <span *ngIf="integrate">
                <img src="assets/images/warning.svg" class="mr-2" style="vertical-align: middle" />
                <small>{{title | translate}}</small>
              </span>
              <span *ngIf="integrated">
                <img src="assets/images/check.svg" class="mr-2" style="vertical-align: middle" />
                <small>{{ "shipments.Integrated" | translate}}</small>
              </span>
            </div>
          </app-col>
          <app-col cols="12" sm="6" md="3" lg="3" xl="3" class="text-primary" color="primary" style="cursor: pointer">
            <div class="flex justify-flex-end">
              <span
                *ngIf="integrate"
                class="d-inline-block"
                [class.cursor-not-allowed]="integrateDisabled"
                [matTooltip]="integrateDisabledReasons"
                [matTooltipDisabled]="!integrateDisabled"
              >
                <button mat-button color="primary" class="btn--xsmall btn--text-primary w-auto" [disabled]="integrateDisabled" (click)="integrateAction()">
                  {{ "shipments.Integrate" | translate}}
                </button>
              </span>
              <button mat-button color="primary" class="btn--xsmall text-nowrap btn--text-primary w-auto" *ngIf="integrated" (click)="action()">
                {{ actionLabel | translate}}
              </button>
            </div>
          </app-col>
        </app-row>
      </div>
      <div class="small flex justify-space-between pt-3" *ngIf="cancelAction && integrated">
        <span class="text-600">{{'shipments.Integrations.DoYouNeedCancel' | translate}}</span>
        <button
          *ngIf="shipment?.bayanWaybills?.length > 1"
          mat-button
          color="warn"
          class="btn--xsmall btn--text-warn w-auto"
          (click)="cancelBayanWaybills()"
        >
          {{'sharedFeatures.CancelAll' | translate}}
        </button>
      </div>
      <mat-divider></mat-divider>

      <div class="mt-3 flex column" *ngIf="shipment?.bayanWaybills?.length && integrated">
        <div *ngFor="let wayBill of shipment.bayanWaybills" class="flex justify-space-between mb-3">
          <ng-container *ngIf="wayBill?.isActive">
            <div class="flex justify-flex-start" [style.gap]="'8px'">
              <app-icon name="bold-forward-arrow" size="xs" class="align-middle"></app-icon>
              <p class="m-0 small text-400 weight-normal">{{wayBill?.waybillId}}</p>
              <p class="m-0 small text-900 weight-normal">{{wayBill?.fromCity}} {{'shipments.Requests.To' | translate}} {{wayBill?.toCity}}</p>
            </div>
            <button mat-button color="warn" class="btn--xsmall btn--text-warn w-auto" (click)="cancelOneBayanWayBill(wayBill?.waybillId)">
              {{'shared.Buttons.Cancel' | translate}}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>

    <mat-card-header>
      <mat-card-title class="title">{{'shipments.ShipmentRequestHistory' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-divider></mat-divider>
      <div class="pl-1" *ngIf="logs?.length">
        <app-shipment-request-history [logs]="logs" [handleEmptyRequestState]="true"></app-shipment-request-history>
      </div>
      <p *ngIf="!logs?.length" class="my-3 text-center text-400 style-italic">
        <small>{{ 'shipments.NoDataAvailableYet' | translate }}</small>
      </p>
    </mat-card-content>
  </div>
</ng-template>
